
import axios from '../../utils/AxiosWrapper'
import axiosMethodRequest from '../../config/service'
import apiCalls from '../../config/apiCalls'
const setCampaignData = (type, data, pagination) => {
	return {
		type: `SET_${type.toUpperCase()}_CAMPAIGN_DATA`,
		payload: data,
		pagination: pagination
	}
}
const setCampaignLoadingState = (type, loadingState) => {
	return {
		type: `SET_${type.toUpperCase()}_CAMPAIGN_DATA_LOADINGSTATE`,
		payload: loadingState
	}
}

const setCurrentCampaignCount = count => {
	return {
		type: 'SET_CURRENT_CAMPAIGN_COUNT',
		payload: count
	}
}

export const setCampaignsPageAction = type => {
	return (page, sizePerPage) => {
		return {
			type: `SET_${type.toUpperCase()}_CAMPAIGN_PAGE`,
			payload: {
				page,
				sizePerPage
			}
		}
	}
}
export const setCampaignsSortAction = type => {
	return (sortField, sortOrder) => {
		return {
			type: `SET_${type.toUpperCase()}_CAMPAIGN_SORT`,
			payload: {
				sortField,
				sortOrder
			}
		}
	}
}

export const setCampaignsSearchAction = type => {
	return (search) => {
		return {
			type: `SET_${type.toUpperCase()}_CAMPAIGN_SEARCH`,
			payload: { search }
		}
	}
}

export const setCampaignsFiltersAction = type => {
	return (filters) => {
		return {
			type: `SET_${type.toUpperCase()}_CAMPAIGN_FILTERS`,
			payload: filters
		}
	}
}

export const setCampaignForEditAction = campaign => {
	return {
		type: 'SET_CAMPAIGN_EDIT',
		payload: campaign
	}
}


export const setSelectedCampaignAction = campaign => {
	return {
		type: 'SET_SELECTED_CAMPAIGN',
		payload: campaign
	}
}

const setCampaignResponseData = data => {
	return {
		type: `SET_CAMPAIGN_RESPONSE_DATA`,
		payload: data
	}
}

export const getCampaignAction = campaignType => {


	return (page, pageSize, filters, type, callback) => {
		return dispatch => {
			setCampaignLoadingState(type, true)
			let url = ''
			let filterCriteria = {};
			filterCriteria['limit'] = pageSize;
			filterCriteria['page'] = page;
			filterCriteria['criteria'] = [];
			filterCriteria['direction'] = 'desc';
			filterCriteria.sortfield = 'created';
			///////global search
			if (filters && filters.globalSearch && filters.globalSearch.value && filters.globalSearch.value.length > 3) {
				filterCriteria.globalSearch = filters.globalSearch
			}
			if (!page) {
				filterCriteria['page'] = 1;
			}
			if (!pageSize) {
				filterCriteria['limit'] = 10;
			}
			////////sorting 
			if (type == "sort" && filters.sortField && filters.sortField.direction) {
				filterCriteria['limit'] = pageSize;
				filterCriteria['page'] = page;
				filterCriteria['criteria'] = [];
				filterCriteria['direction'] = filters.sortField.direction
				filterCriteria.sortfield = filters.sortField.sortfield;
			}
			url = `${apiCalls.createCampaign}?filter=${JSON.stringify(filterCriteria)}${campaignType ? `&campaignType=${campaignType}` : ''}`;
			dispatch(setCampaignLoadingState(campaignType, true))
			return axiosMethodRequest('GET', url).then((response) => {
				if (response && response.data && response.data.respCode) {
					let data = response.data.campaigns
					let pagination = response.data.pagination
					if (callback)
						callback(data, pagination, 'success')
					dispatch(setCampaignData(campaignType, data, pagination))
				} else {
					callback(response.data.errorMessage, '', 'error')
				}
				dispatch(setCampaignLoadingState(campaignType, false))
			})
		}
	}
}

export const getCampaignByIdAction = id => {
	return dispatch => {
		return axiosMethodRequest("GET",`campaigns/${id}`)
			// .get(`/campaigns/${id}`)
			.then(res => {
				let data = res.data
				dispatch(setSelectedCampaignAction(data))
			})
	}
}


export const deleteCampaignAction = (campaign, callback) => {
	return dispatch => {
		return axiosMethodRequest('DELETE', `campaigns/${campaign._id}`).then((response) => {
			if (response && response.data && response.data.respCode) {
				if (callback)
					callback()
			} else {
				if (callback)
					callback(response.data.errorMessage)
			}
		})
	}
}

export const getCampaignNameAction = (callback) => {
	return dispatch => {
		return axiosMethodRequest('GET', apiCalls.getCampaignName).then((response) => {
			if (response && response.data && response.data.respCode) {
				callback(response.data, 'success')
			} else {
				callback(response.data.errorMessage, 'error')
			}
		})
	}
}

export const createCampaignAction = (data, callback) => {
	return dispatch => {
		return axiosMethodRequest('POST', apiCalls.createCampaign + '?response=true', data).then((response) => {
			if (response && response.data && response.data.respCode) {
				// callback(response.data.respMessage)
				if (response.data.template) {
					dispatch(setCampaignResponseData(response.data.template))
				}
				callback(response.data, 'success')
			} else {
				callback(response.data.errorMessage, 'error')
			}
		})
	}
}

export const bulkCreateCampaignAction = (data, callback) => {
	return dispatch => {
		return axios.post('/campaigns/bulk', data)
			.then(res => {
				callback(null)
			})
			.catch(err => {
				callback(err)
			})
	}
}

export const editCampaignAction = (data, callback) => {
	return dispatch => {
		return axiosMethodRequest('PUT', `${apiCalls.createCampaign}/${data._id}`, data).then((response) => {
			if (response && response.data && response.data.respCode) {
				// callback(response.data.respMessage)
				callback(response.data.respMessage, 'success')
			} else {
				callback(response.data.errorMessage, 'error')
			}
		})
	}
}

export const getCurrentCampaignCountAction = () => {
	return dispatch => {
		return axios.get(`/campaigns/current/count`)
			.then(res => {
				dispatch(setCurrentCampaignCount(res.data))
			})
			.catch(err => {

			})
	}
}

export const savecampaignResponseAction = (data) => {
	return dispatch => {
		return dispatch(setCampaignResponseData(data))
	}
}

